import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Support: the inbox of threads, one thread, and a first message to somebody. */
export const Route = createFileRoute("/_app/specialists/support")({
  component: Outlet,
});
